import { motion } from "framer-motion";
import { SectionHeading, SectionLabel } from "./Section";

const tools = [
  { name: "ChatGPT", cat: "Reasoning" },
  { name: "Claude", cat: "Reasoning" },
  { name: "Gemini", cat: "Multimodal" },
  { name: "Perplexity", cat: "Research" },
  { name: "Grok", cat: "Realtime" },
  { name: "Copilot", cat: "Code" },
  { name: "Kimi", cat: "Long context" },
  { name: "Midjourney", cat: "Image" },
  { name: "Veo", cat: "Video" },
  { name: "Sora", cat: "Video" },
  { name: "Kling", cat: "Video" },
  { name: "Higgsfield", cat: "Motion" },
  { name: "HeyGen", cat: "Avatar" },
  { name: "Suno", cat: "Audio" },
  { name: "Lovable", cat: "Build" },
  { name: "Bolt", cat: "Build" },
  { name: "n8n", cat: "Automation" },
  { name: "Zapier", cat: "Automation" },
  { name: "Gamma", cat: "Design" },
  { name: "Google Flow", cat: "Workflow" },
];

export function Stack() {
  return (
    <section id="stack" className="relative py-32">
      <div className="mx-auto max-w-7xl px-6">
        <div className="mb-16 max-w-2xl">
          <SectionLabel>Toolkit</SectionLabel>
          <SectionHeading>AI Stack I Explore</SectionHeading>
          <p className="mt-5 text-muted-foreground">
            A working playground of the tools shaping the next decade — used, tested, and pushed.
          </p>
        </div>

        <div className="grid grid-cols-2 gap-3 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5">
          {tools.map((t, i) => (
            <motion.div
              key={t.name}
              initial={{ opacity: 0, y: 18 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-40px" }}
              transition={{ duration: 0.5, delay: (i % 10) * 0.04 }}
              className="group relative overflow-hidden rounded-xl border border-white/[0.06] bg-white/[0.02] p-5 transition-all hover:-translate-y-0.5 hover:border-electric/30 hover:bg-white/[0.04]"
            >
              <div className="pointer-events-none absolute inset-0 opacity-0 transition-opacity duration-500 group-hover:opacity-100">
                <div className="absolute -inset-px rounded-xl bg-[radial-gradient(circle_at_30%_20%,oklch(0.7_0.22_250/0.25),transparent_60%)]" />
              </div>
              <div className="relative">
                <div className="text-[11px] uppercase tracking-widest text-muted-foreground">
                  {t.cat}
                </div>
                <div className="mt-1 text-base font-medium tracking-tight">{t.name}</div>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
